







import Vue from 'vue'
import Groups from '@/components/parsers/Groups.vue'
import { Page } from '@/config/interfaces'

export default Vue.extend({
  name: 'Pages',

  components: { Groups },

  computed: {
    /*
    The API can return multiple pages at once, but only the first one is used.
    */
    getPage (): Page {
      if (Object.prototype.hasOwnProperty.call(this.mainData, 'pages')) {
        const mainData = this.mainData as Record<string, Array<Page>>
        return mainData.pages[0]
      }
      const mainData = this.mainData as Array<Page>
      return mainData[0]
    }
  },

  props: {
    mainData: {
      required: true
    }
  }
})
